import { createColumn, ColumnWidth } from '../createColumn';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import ColumnStrings from '../columns.resx';
import { Facet } from '../../../models/Facet';
import { DateField } from '../../fields/date/DateField';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { dateModifiedFacet } from '../../../facets/ItemFacets';
import { localeFacet, configurationItemKey } from '../../../facets/ConfigurationFacets';
import { getRelativeDateTimeStringPast } from '@ms/utilities-date-time/lib/relativePast';

export const dateModifiedColumn: IColumn = createColumn({
  key: new Facet('dateModifiedColumn').id,
  name: ColumnStrings.ModifiedDate,
  fieldName: '',
  minWidth: ColumnWidth.regularMin,
  maxWidth: ColumnWidth.regularMax,
  isCollapsable: true
}, DateField)((itemCache: IItemCache, itemKey: string) => {
  const dateModified = itemCache.demandItemFacet(dateModifiedFacet, itemKey);
  const time = dateModified && new Date(dateModified).getTime();

  if (typeof time === 'number' && !isNaN(time)) {
    const locale = itemCache.demandItemFacet(localeFacet, configurationItemKey);

    const language = locale && locale.language || window.navigator.language;

    return language ? {
      text: getRelativeDateTimeStringPast(new Date(time), language)
    } : {
        dateValue: time
      };
  } else {
    return {
      text: ''
    };
  }
});
